import { Component, OnInit } from '@angular/core';
import {ServiceAccessComponent} from '../../service-access/service-access.component';
import {PortalServiceFactoryService} from '../../../../services/portal-service-factory.service';
import {AlertaService} from '../../../../../../shared/services/alerta.service';

@Component({
  selector: 'app-chacon-smsservice-access',
  templateUrl: './chacon-smsservice-access.component.html',
  styleUrls: ['./chacon-smsservice-access.component.scss']
})
export class ChaconSmsserviceAccessComponent extends ServiceAccessComponent implements OnInit {

    constructor(protected portalServiceFactory: PortalServiceFactoryService, protected alertaHandler:AlertaService) {
        super(portalServiceFactory, alertaHandler);
    }

    ngOnInit() {
        super.ngOnInit();
    }

}



// WEBPACK FOOTER //
// /var/www/backend/src/app/phone/config/form/components/chacon-sms/chacon-smsservice-access/chacon-smsservice-access.component.ts